import { Typography } from "@mui/material"
import Dialog from "components/common/dialog/dialog"
import { Trans, useTranslation } from "react-i18next"

import { HREFLINK } from "../link/hreflink"

interface IProps {
  open: boolean
  onClose: () => void
  onActionButtonClick: () => void
  isLoading: boolean
  isExport?: boolean
  isHelper?: boolean
  isSchool?: boolean
  isGroups?: boolean
  customActionButtonsSlot?: React.ReactNode
}

const DialogUpgradeAccount = ({
  open,
  onClose,
  onActionButtonClick,
  isLoading,
  isExport,
  isHelper,
  isSchool,
  isGroups,
  customActionButtonsSlot,
}: IProps) => {
  const { t } = useTranslation()
  return (
    <Dialog
      open={open}
      onClose={onClose}
      isLoading={isLoading}
      customActionButtonsSlot={customActionButtonsSlot}
      titleText={
        isExport
          ? t("jobs.exportData")
          : isHelper
          ? t("studentHelpers.studentHelper")
          : isSchool
          ? t("students.addAllStudents")
          : isGroups
          ? t("group.upgradeTitle")
          : t("coteachers.inviteCoteacher")
      }
      actionAcceptText={t("coteachers.upgrade")}
      onActionButtonClick={onActionButtonClick}
      actionAcceptButtonProps={{ disabled: isLoading }}
    >
      <Typography color="mockup.neutral10" fontWeight="500" variant="body1">
        <Trans
          i18nKey={
            isExport
              ? "jobs.descriptionUpgradeTeacherExport"
              : isHelper
              ? "studentHelpers.descriptionUpgradeTeacher"
              : isSchool
              ? "students.descriptionUpgradeAddAllStudents"
              : isGroups
              ? "group.upgradePlansNote"
              : "coteachers.descriptionUpgradeTeacher"
          }
          components={{
            Link: HREFLINK,
          }}
        />
      </Typography>
    </Dialog>
  )
}

export default DialogUpgradeAccount
